import { useList } from './List.h'
import { usePermission } from '@shared/hooks/permissions'

import Typography from '@mui/material/Typography'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import LinearProgress from '@mui/material/LinearProgress'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import CircleIcon from '@mui/icons-material/Circle'
import since from '@shared/utils/since'

export default function Data() {
    const {
        query,
        anchor,
        setAnchor,
        setInstance,

        handleDelete,
        handleFetchInstance
    } = useList()
    const { hasPermission } = usePermission()

    return query.isLoading
        ? <LinearProgress />
        : query.error
            ? <Typography className='centerized'>حدث خطأ</Typography>
            : (
                <>
                    {query.data.length == 0 ? (
                        <Typography className='centerized'>
                            لا توجد بيانات
                        </Typography>
                    ) : (
                        <List>
                            {query.data.map(user =>
                                <ListItem
                                    key={user.id}
                                    secondaryAction={(hasPermission('change_user') && hasPermission('delete_user')) &&
                                        <IconButton onClick={e => setAnchor(e.currentTarget)}>
                                            <MoreVertIcon />
                                        </IconButton>
                                    }
                                    onClick={() => setInstance(user)}
                                >
                                    <ListItemIcon>
                                        {user.is_active
                                            ? (
                                                <Tooltip title='حساب مفعل'>
                                                    <CircleIcon
                                                        sx={{fontSize: 10}}
                                                        color='success'
                                                    />
                                                </Tooltip>
                                            )
                                            : (
                                                <Tooltip title='حساب موقف'>
                                                    <CircleIcon
                                                        sx={{fontSize: 10}}
                                                        color='error'
                                                    />
                                                </Tooltip>
                                            )
                                        }
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={`${user.first_name} ${user.last_name}`}
                                        secondary={since(user.last_activity)}
                                    />
                                </ListItem>
                            )}
                            <div style={{height: '100px'}}></div>
                        </List>
                    )}
                    {(hasPermission('change_user') && hasPermission('delete_user')) &&
                        <Menu
                            open={!!anchor}
                            anchorEl={anchor}
                            onClose={() => setAnchor(null)}
                        >
                            {hasPermission('change_user') && <MenuItem onClick={handleFetchInstance}>تعديل</MenuItem>}
                            {hasPermission('delete_user') && <MenuItem onClick={handleDelete}>حذف</MenuItem>}
                        </Menu>
                    }
                </>
            )
}